<script>
  import { redirect } from "@roxi/routify"

  $redirect("/messages/inbox")
</script>
